import { useLottie } from "lottie-react";
import { useAnimationStore } from "../stores/animation.store";

interface ContainerProps {
  animationData?: any;
  animationName?: string;
}

const AnimationContainer: React.FC<ContainerProps> = ({
  animationData,
  animationName
}) => {
  const animations = useAnimationStore(state => state.animations);
  const loading = useAnimationStore(state => state.loading);
  const data = animationData
    ? animationData
    : animationName && animations[animationName];
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: data,
    style: {
      height: 250
    }
  };
  const { View } = useLottie(defaultOptions);
  if (loading) {
    return <div>Loading...</div>;
  }
  return <>{View}</>;
};

export default AnimationContainer;
